module.exports = __webpack_public_path__ + "img/horizontal_7_2_pp2_9006.ef5f58fb.png";